// extracted by mini-css-extract-plugin
export default {"upbtn":"ScrollToTopButton_upbtn__bj3Oq","show":"ScrollToTopButton_show__qPNKk","pulse":"ScrollToTopButton_pulse__kXTjQ"};